import { render, staticRenderFns } from "./ModalDailyLimit.vue?vue&type=template&id=23855e82&scoped=true&"
import script from "./ModalDailyLimit.vue?vue&type=script&lang=js&"
export * from "./ModalDailyLimit.vue?vue&type=script&lang=js&"
import style0 from "./ModalDailyLimit.vue?vue&type=style&index=0&id=23855e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23855e82",
  null
  
)

export default component.exports